module.exports = __webpack_public_path__ + "img/huc.f89dcc49.svg";